import { Database } from "@shared/lib/database/database.types";
import { createClient } from "@supabase/supabase-js";

export const supabaseClient = createClient<Database>(import.meta.env.VITE_SUPABASE_URL, import.meta.env.VITE_SUPABASE_ANON_KEY, {
  auth: {
    detectSessionInUrl: false,
    storageKey: import.meta.env.VITE_SUPABASE_STORAGE_KEY,
  },
});
